module.exports = __webpack_public_path__ + "static/media/punchestown-tacecourse-event-venue.3ef8b357.png";